module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-4-1.b236b414.png";